import React from "react";
import Grid from "@mui/material/Grid";

/* eslint @typescript-eslint/no-explicit-any: ["off"] */
type PaperWrapperProps = {
    className?: string;
    cusStyle?: any;
    children: React.ReactNode;
    innerCusStyle?: React.CSSProperties;
};

const PaperWrapper: React.FC<PaperWrapperProps> = ({ className, cusStyle, children, innerCusStyle }) => {
    return (
        <Grid className={className || "paper-wrapper"} style={cusStyle}>
            <Grid style={innerCusStyle} item>{children}</Grid>
        </Grid>
    );
};

export default PaperWrapper;
